import React from "react";

import type { FeedItem } from "@app/analytics/Home/types";

import ActionItemDetailsPanel from "./ActionItemDetailsPanel";
import DetailsEducationCard from "./DetailsEducationCard";
import KeyQuestionAnswerDetailsPanel from "./KeyQuestionAnswerDetailsPanel";
import KeyQuestionDetailsPanel from "./KeyQuestionDetailsPanel";
import MeetingReportDetailsPanel from "./MeetingReportDetailsPanel";
import MeetingReportErrorDetailsPanel from "./MeetingReportErrorDetailsPanel";

export interface DetailsPanelProps {
  item: FeedItem | null;
  onClose: () => void;
}

const DetailsPanel = ({ item, onClose }: DetailsPanelProps) => {
  if (!item) return <DetailsEducationCard />;

  switch (item.type) {
    case "action_item":
      return <ActionItemDetailsPanel item={item} onClose={onClose} />;
    case "key_question":
      return <KeyQuestionDetailsPanel item={item} onClose={onClose} />;
    case "key_question_answer":
      return <KeyQuestionAnswerDetailsPanel item={item} onClose={onClose} />;
    case "meeting_report":
      return <MeetingReportDetailsPanel item={item} onClose={onClose} />;
    case "meeting_report_error":
      return <MeetingReportErrorDetailsPanel item={item} onClose={onClose} />;
    default:
      return <DetailsEducationCard />;
  }
};

export default DetailsPanel;
